module.exports = __webpack_public_path__ + "assets/static/jpg/iban.83d0d19cb3dd65dc563293ea2676fa05.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/iban.jpg
 ** module id = 490
 ** module chunks = 1
 **/